import styled from 'styled-components';
export const CookingTimeAndPeopleContainer = styled.div.withConfig({
  displayName: "CookingTimeAndPeoplestyle__CookingTimeAndPeopleContainer",
  componentId: "sc-1fbsayg-0"
})(["", ""], {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "0.5rem"
});